const topics = [
  { id: 1, name: '暑期档推荐', heat: '128.6w', icon: 'ri-sun-line', color: 'bg-accent-100 text-accent-700' },
  { id: 2, name: '悬疑推理', heat: '96.3w', icon: 'ri-search-eye-line', color: 'bg-secondary-100 text-secondary-700' },
  { id: 3, name: '科幻大片', heat: '87.1w', icon: 'ri-rocket-line', color: 'bg-primary-100 text-primary-700' },
  { id: 4, name: '豆瓣高分', heat: '74.8w', icon: 'ri-star-line', color: 'bg-accent-100 text-accent-700' },
  { id: 5, name: '动作冒险', heat: '68.2w', icon: 'ri-sword-line', color: 'bg-secondary-100 text-secondary-700' },
  { id: 6, name: '喜剧合家欢', heat: '59.5w', icon: 'ri-emotion-laugh-line', color: 'bg-primary-100 text-primary-700' },
  { id: 7, name: '国产新片', heat: '52.3w', icon: 'ri-flag-2-line', color: 'bg-accent-100 text-accent-700' },
  { id: 8, name: '日韩精选', heat: '45.7w', icon: 'ri-earth-line', color: 'bg-secondary-100 text-secondary-700' },
  { id: 9, name: '动画电影', heat: '38.9w', icon: 'ri-magic-line', color: 'bg-primary-100 text-primary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            最受关注的电影话题与分类标签，发现更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#index"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <span className={`w-10 h-10 flex items-center justify-center rounded-full ${topic.color} transition-transform duration-300 group-hover:scale-110`}>
                <i className={`${topic.icon} text-lg`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-300">
                <i className="ri-fire-line mr-0.5"></i>
                {topic.heat} 热度
              </span>
            </a>
          ))}
        </div>

        <div className="mt-4 text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-100 border border-background-200/50 text-xs text-foreground-400">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
            实时热度更新中，数据每5分钟刷新
          </span>
        </div>
      </div>
    </section>
  );
}